import React from "react";
import "../../../src/assets/css/UC/noRecordFound.scss";

const NoRecordFound = ({ language }) => {
    return (
        <div className="no-records-found">
            <div className="no-records-content">
                <div className="no-records-icon">
                    <i className="fa fa-search"></i>
                </div>
                <h2 className="no-records-title">{language?.noRecordFound?.title || "No Records Found"}</h2>
                <p className="no-records-message">
                    {language?.noRecordFound?.message || "There are no records to display based on the current criteria."}
                </p>
                {/* <div className="no-records-suggestions">
                    <ul>
                        <li>{language?.noRecordFound?.suggestion1 || "Try adjusting your search filters"}</li>
                        <li>{language?.noRecordFound?.suggestion2 || "Check your spelling and try again"}</li>
                        <li>{language?.noRecordFound?.suggestion3 || "Clear all filters to see all available records"}</li>
                    </ul>
                </div> */}
            </div>
        </div>
    );
};

export default NoRecordFound;